<template>
  <div class="form-course mx-auto my-10">
    <ValidationObserver
      ref="observer"
      v-slot="{ invalid }"
    >
      <form @submit.prevent="onSubmit">
        <ValidationProvider name="name" rules="required" v-slot="{ errors }">
          <v-text-field
            label="Nome"
            type="text"
            v-model="course.name"
            :error-messages="errors"
            filled
            required
          />
        </ValidationProvider>
        <ValidationProvider name="description" v-slot="{ errors }">
          <v-textarea
            label="Descrição"
            type="text"
            v-model="course.description"
            :error-messages="errors"
            filled
            auto-grow
          ></v-textarea>
        </ValidationProvider>
        <ValidationProvider name="code" rules="required" v-slot="{ errors }">
          <v-text-field
            label="Código"
            type="text"
            v-model="course.code"
            :error-messages="errors"
            filled
            required
          />
        </ValidationProvider>
        <div :key="index" v-for="(machine, index) in course.machines">
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="12">
              <strong>Máquina {{ index+1 }} | {{ machine.name }}</strong>
            </v-col>
          </v-row>
          <div v-if="machine.type === 'gcp'">
            <FormGcpMachine
              :course-id="course.id"
              :machine="machine"
              @remove="removeMachine(index)"
            ></FormGcpMachine>
          </div>
          <div v-else>
            Máquina desconhecida
            {{ machine }}
          </div>
        </div>

        <v-divider class="my-5"></v-divider>
        <h3 class="my-3">Adicionar máquina</h3>
        <v-row>
          <v-col cols="8">
            <v-select
              v-model="platform"
              :items="vmPlatforms"
              item-text="name"
              item-value="value"
              label="Plataform da máquina"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-btn
              tile
              large
              color="success"
              :disabled="!platform.length"
              v-on:click="addMachine()"
            >
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="my-5"></v-divider>

        <v-btn
          block
          rounded
          large
          class="my-2"
          type="submit"
          color="primary"
          :disabled="invalid"
        >
          {{ isNew ? 'Criar' : 'Editar' }}
        </v-btn>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Course from '@/models/course';
import FormGcpMachine from '@/pages/admin/components/course/FormGcpMachine';

export default {
  name: 'FormCourse',
  emits: ['submitCourse'],
  components: { FormGcpMachine },
  props: {
    isNew: Boolean,
    course: Course,
  },
  data: () => ({
    vmPlatforms: [
      {
        name: 'Google Cloud Platform',
        value: 'gcp',
      }
    ],
    platform: '',
  }),
  mounted() {
  },
  methods: {
    addMachine() {
      if (!this.platform.length) {
        return;
      }

      this.course.machines.push(this.buildDefaultMachine(this.platform));

      this.platform = '';
    },
    buildDefaultMachine(platform) {
      const baseMachine = {
        id: '',
        type: platform,
        name: '',
      };

      switch (platform) {
        case 'gcp':
          return Object.assign(baseMachine, { gcp: this.buildDefaultGcp() });
      }

      return baseMachine;
    },
    buildDefaultGcp() {
      return {
        zone: 'us-central1-a',
        image: '',
        type: 'e2-micro',
        disks: [
          {
            boot: true,
            autoDelete: true,
            size: 10,
            type: 'pd-standard',
          }
        ],
        networks: [
          {
            name: 'vpc4cloud',
            networkIp: '',
          }
        ],
        enableIntegrityMonitoring: true,
        enableSecureBoot: true,
        enableVtpm: true,
      };
    },
    removeMachine(index) {
      this.course.machines.splice(index, 1);
    },
    onSubmit() {
      this.$refs.observer.validate();

      this.$emit('submitCourse', this.course);
    }
  }
};
</script>

<style scoped>
.form-course {
  max-width: 50%;
}
</style>
